/* eslint-disable react/prop-types */
import images from "../../assets/images/assets";

const SectionHeader1 = ({ title }) => {
  return (
    <h2 className=" playfair-display  heading-1 relative text-prime-red">
      <img
        src={images.star1}
        alt="decorative"
        className="w-4 absolute left-40 md:left-85 lg:left-[50%] -top-3 md:-top-5 lg:-top-6"
      />
      {title}
    </h2>
  );
};

export default SectionHeader1;
